module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-ties.e528ea38.png";